import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const sizeClass = {
    sm: '[&_svg]:size-3',
    md: '[&_svg]:size-4',
    lg: '[&_svg]:size-5'
};
/** Normalizes arbitrary icon artwork and its accessible-name contract. */ export const SpecraIcon = /*#__PURE__*/ React.forwardRef(({ children, className, label, size = 'md', ...props }, ref)=>/*#__PURE__*/ _jsx("span", {
        "aria-hidden": label ? undefined : true,
        "aria-label": label,
        className: cn('inline-flex shrink-0 items-center justify-center', sizeClass[size], className),
        ref: ref,
        role: "img",
        ...props,
        children: children
    }));
SpecraIcon.displayName = 'SpecraIcon';
